<div #ticketRef style="width:1400px; margin: auto;">
    <section class="sectionHeader">
        <div class="wrapper">
            <div class="logo_wrapper">
                <img src="../../../../assets/belairtrip_assets/main/belairtrip.svg" alt="" class="img-fluid">
            </div>
            <div class="officeInformation">
                <div class="innerWrapper text-end">
                    <ul class="list-group list-group-flush">
                        <li class="list-group-item p-0" style="background-color:transparent;">Email Address: <span>support&#x40;belairtrip.com</span></li>
                        <li class="list-group-item p-0" style="background-color:transparent;">Contact Number: <span>+91-9355019962 (10:00 to 19:00 IST)</span></li>
                        <!-- <li class="list-group-item p-0" style="background-color:transparent;">Contact Number: +011-42521000 (24X7)</li> -->
                    </ul>
                </div>
            </div>
        </div>
    </section>
    <section class="sectionTicketsBody">
        <div class="headerFlightbooking">
            <div class="wrapper">
                <div class="wrapperInner">
                    <img src="../../../../assets/belairtrip_assets/main/flight-route.png" alt="" class="img-fluid">
                    <div class="content">
                        <h4>Flight Booking</h4>
                        <p>Booking Id: <span> {{isFlightInfo?.id}}</span></p>
                    </div>
                </div>
                <div class="spacer"></div>
                <div class="wrapperInner">
                    <div class="content">
                        <h4>Booking Reference</h4>
                        <p>Airline PNR: <span>{{isFlightInfo?.segments | uniqueCrsPnr}}</span></p>
                    </div>
                </div>
            </div>
        </div>
        <section class="barcodeImageSection">
            <section class="barcodeImage">
                <img [src]="isFlightInfo?.extra_info?.barcodeImage" [alt]="isFlightInfo?.id" class="img-fluid">
            </section>
        </section>
        <div class="bodyTickets_flight__">
            <ng-container *ngFor="let item of isFlightInfo?.segments">
                <div class="wrapperFlightInfo">
                    <div class="headingItierary headerRoute">
                        <h3>{{item.source | uppercase}}&nbsp;<mat-icon color="primary">flight</mat-icon>&nbsp;{{item.destination | uppercase}}</h3>
                        <div class="spacer"></div>
                        <p style="font-size: 18px;"><strong>Journey Duration </strong>&nbsp;&nbsp;{{item?.journey_duration}}</p>
                    </div>
                    <div class="flight_deatils">
                        <ng-container *ngFor="let subItem of item['routes']">
                            <div class="craft_info">
                                <div class="flight_headerInfo">
                                    <img [src]="subItem.carrier_code | imageUrl" [alt]="subItem.carrier_code" class="img-fluid">
                                    <div class="flight_contentInfo">
                                        <p>{{subItem.carrier_name}} ({{subItem?.carrier_code}})</p>
                                        <p><span>{{subItem.carrier_code}}-{{subItem.flight_number}}</span></p>
                                    </div>
                                </div>
                                <div class="flightWrapper">
                                    <div class="flightInnerWrapper">
                                        <p class="flight_time_code">{{subItem?.dep_time | date: 'HH:mm' }}&nbsp;&nbsp;<span>({{subItem?.source_code}})</span></p>
                                        <p class="flight_date">{{subItem?.dep_time | date: 'EEEE, dd-MMM-yyyy' }}</p>
                                        <p class="airport_name">{{subItem?.source_airport_name}},<span> {{subItem?.source_city}}</span></p>
                                        <p class="terminal" *ngIf="subItem?.dep_terminal">Terminal: {{subItem?.dep_terminal}}</p>
                                    </div>
                                    <div class="spacer"></div>
                                    <div class="flightInnerWrapper">
                                        <p class="flight_time_code">{{subItem?.arr_time | date: 'HH:mm' }}&nbsp;&nbsp;<span>({{subItem?.destination_code}})</span></p>
                                        <p class="flight_date">{{subItem?.arr_time | date: 'EEEE, dd-MMM-yyyy' }}</p>
                                        <p class="airport_name">{{subItem?.destination_airport_name}},<span> {{subItem?.destination_city}}</span></p>
                                        <p class="terminal" *ngIf="subItem?.arr_terminal">Terminal: {{subItem?.arr_terminal}}</p>
                                    </div>
                                </div>
                            </div>
                        </ng-container>
                        <section class="passengersSection">
                            <table class="w-100 table align-middle table-bordered">
                                <thead class="table-light">
                                    <tr class="align-middle">
                                        <th>Full Name</th>
                                        <th>Passenger Type</th>
                                        <th>Cabin</th>
                                        <th>Seat</th>
                                        <th>Ticket No.</th>
                                        <th>Barcode</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let subItem of item['passengers']">
                                        <tr>
                                            <td style="font-weight: 600;">{{subItem?.name}}&nbsp;<strong  style="font-weight: 300;" [ngStyle]="{ color: subItem?.status?.toLowerCase() === 'ok' ? 'green' : 'inherit' }">
                                                ({{ subItem?.status?.toLowerCase() === 'ok' ? 'Confirmed' : subItem?.status }})</strong>
                                            </td>
                                            <td>{{subItem?.type}}</td>
                                            <td>{{subItem?.cabin}}</td>
                                            <td [innerHTML]="subItem?.ancillaries | seatFilterTickets"></td>
                                            <td>{{ subItem?.ticket_no || '--' }}</td>
                                            <td>
                                                <ng-container *ngIf="!subItem.imgError; else noImg">
                                                    <img [src]="subItem.barcode_image" [alt]="subItem.id" class="img-fluid w-100" (error)="subItem.imgError = true">
                                                </ng-container>
                                                <ng-template #noImg>N/A</ng-template>
                                            </td>
                                        </tr>
                                    </ng-container>
                                </tbody>
                            </table>
                        </section>
                        <!-- {{item['passengers'] | json}} -->
                    </div>
                </div>
            </ng-container>
            <ul>
                <li *ngFor="let item of instruction.getInstructions() | highlightKey: 'government-issued, passenger'" [innerHtml]="item" style="font-size:20px; line-height: 22px; margin-bottom: 4px; font-weight: 300;"></li>
            </ul>
        </div>
        <section class="baggageInfoSection pt-3">
            <h3 style="font-size:22px; line-height: 16px; margin-bottom: 20px; font-weight: 700;">Baggage Information</h3>
            <ul>
                <li *ngFor="let item of instruction.getInstructions() | highlightKey: 'baggage'" [innerHtml]="item" style="font-size:20px; line-height: 22px; margin-bottom: 4px; font-weight: 300;"></li>
            </ul>
            <section class="baggage_info">
                <!-- {{isFlightInfo | baggageFormat | json}} -->
                <div *ngFor="let item_bg of isFlightInfo | baggageFormat">
                    <h4 style="margin-top: 8px; font-size:20px; line-height: 16px; margin-bottom: 20px; font-weight: 600;">{{item_bg?.route | uppercase}}</h4>
                    <table class="w-50 table table-bordered align-middle mb-5">
                        <thead class="table-light">
                            <tr>
                                <th>Type</th>
                                <th>Check-in</th>
                                <th>Cabin</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let _bg of item_bg['items']">
                                <td>{{_bg?.type}} {{_bg?.index}}</td>
                                <td>{{_bg?.value}}</td>
                                <td>--</td>
                            </tr>
                        </tbody>
                    </table>
                    <!-- {{item_bg | json}} -->
                </div>
            </section>
            <!-- {{isFlightInfo['extra_info']?.baggage | json}} -->
        </section>
        <section class="cancelInformarionSection pt-3">
            <h3 style="font-size:22px; line-height: 16px; margin-bottom: 20px; font-weight: 700;">Cancellation Refunds Information</h3>
            <ul>
                <li *ngFor="let item of instruction.getInstructions() | highlightKey: 'cancel, Refunds'" [innerHtml]="item" style="font-size:20px; line-height: 22px; margin-bottom: 4px; font-weight: 300;"></li>
            </ul>
            <section class="cancel_info" *ngIf="isFlightInfo['extra_info']?.cancel.length">
                <div *ngFor="let item_CN of isFlightInfo | cancelFormat">
                    <h4 style="margin-top: 8px; font-size:20px; line-height: 16px; margin-bottom: 20px; font-weight: 600;">{{item_CN?.route | uppercase}}</h4>
                    <table class="w-75 table table-bordered align-middle mb-5">
                        <thead class="table-light">
                            <tr>
                                <th>Type</th>
                                <th>Value</th>
                                <!-- <th>Cabin</th> -->
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let _CN of item_CN['items']">
                                <td>{{_CN?.type}}</td>
                                <td>{{_CN?.value | currency: isFlightInfo?.currency}}</td>
                                <!-- <td>--</td> -->
                            </tr>
                        </tbody>
                    </table>
                </div>
                <!-- {{isFlightInfo | cancelFormat | json}} -->
            </section>
        </section>
        <section class="ExtraServicesSection mt-3" *ngIf="hasAnyAncillaries()">
            <h3 style="font-size:22px; line-height: 16px; margin-bottom: 20px; font-weight: 700;">Ancillaries Information</h3>
            <section class="ancillariesSection">
                <ng-container *ngFor="let item of isFlightInfo?.segments">
                    <div class="wrapperFlightInfo">
                        <div class="headingItierary headerRoute">
                            <h3>{{item.source | uppercase}}&nbsp;<mat-icon color="primary">flight</mat-icon>&nbsp;{{item.destination | uppercase}}</h3>
                            <div class="spacer"></div>
                        </div>
                        <table class="w-100 table table-bordered align-middle mb-5">
                            <ng-container *ngFor="let subItem of item['passengers']">
                                <thead>
                                    <tr>
                                        <th colspan="7">{{subItem?.name}}</th>
                                    </tr>
                                </thead>
                                <!--  -->
                                <thead class="table-light">
                                    <tr>
                                        <th>Route</th>
                                        <th>Type</th>
                                        <!-- <th>Quantity</th> -->
                                        <th>SSR Detail</th>
                                        <th>Amount</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <ng-container *ngFor="let routeData of subItem?.ancillaries | ancillariesByRoute">
                                        <ng-container *ngFor="let anc of routeData.items; let i = index">
                                            <!-- Only show rows with type 'seat', 'meal', or 'baggage' -->
                                            <tr *ngIf="['seat', 'meal', 'baggage'].includes(anc?.type)">
                                                <td *ngIf="i === 0" [attr.rowspan]="routeData.items.length">{{ routeData.route }}</td>
                                                <td>{{ anc?.type | titlecase }} <ng-container *ngIf="anc?.type === 'seat'">({{ anc?.code }})</ng-container></td>
                                                <!-- <td>{{ anc?.quantity }}</td> -->
                                                <td class="ssr_detail">{{ anc?.ssr_detail | splitCamelCase}}</td>
                                                <td>{{ anc?.amount | currency: isFlightInfo?.currency }}</td>
                                                <td>{{ anc?.status }}</td>
                                            </tr>
                                        </ng-container>
                                    </ng-container>
                                </tbody>
                            </ng-container>
                        </table>
                    </div>
                </ng-container>
            </section>
        </section>
        <section class="paymentSummarySection">
            <h3 style="font-size:22px; line-height: 16px; margin-bottom: 20px; font-weight: 700;">Payment Information</h3>
            <section class="paymentSummary">
                <table class="w-50 align-middle mb-5">
                        <tbody>
                            <tr>
                                <th>Basic Fare</th>
                                <td>{{isFlightInfo?.base_fare | currency: isFlightInfo?.currency}}</td>
                            </tr>
                            <tr>
                                <th>Taxes</th>
                                <td>{{isFlightInfo?.taxes + isFlightInfo?.fees | currency: isFlightInfo?.currency}}</td>
                            </tr>
                            <tr>
                                <th>Service Taxes</th>
                                <td>{{isFlightInfo?.service_tax | currency: isFlightInfo?.currency}}</td>
                            </tr>
                            <tr class="insurance_fee">
                                <th>Insurance</th>
                                <td>{{isFlightInfo?.insurance_fee | currency: isFlightInfo?.currency}}</td>
                            </tr>
                            <tr class="promo_discount">
                                <th>Promo Discount</th>
                                <td>{{isFlightInfo?.promo_discount | currency: isFlightInfo?.currency}}</td>
                            </tr>
                            <tr>
                                <th>Extra Services</th>
                                <td>{{isFlightInfo?.ancillaries_amount | currency: isFlightInfo?.currency}}</td>
                            </tr>
                            <tr *ngIf="isFlightInfo?.pg_offers && isFlightInfo.pg_offers.length > 0">
                                <th>Payment Offer</th>
                                <td>{{isFlightInfo?.pg_offers[0]?.discount | currency: isFlightInfo?.currency}}</td>
                            </tr>
                            <tr>
                                <th>Convenience fee</th>
                                <td>{{isFlightInfo?.convenience_fee | currency: isFlightInfo?.currency}}</td>
                            </tr>
                            <tr class="total_amount">
                                <th><strong>Total Amount</strong></th>
                                <td><strong>{{isFlightInfo?.total_amount | currency: isFlightInfo?.currency}}</strong></td>
                            </tr>
                        </tbody>
                    </table>
            </section>
        </section>
    </section>
    <section class="sectionFooter T_C_Section">
        <mat-card class="matcardWrapper importantInstructions">
            <h3 style="font-size:22px; line-height: 16px; margin-bottom: 20px;">Terms and Conditions</h3>
            <!-- <h4>Terms and Conditions</h4> -->
            <ul>
                <li *ngFor="let item of instruction.getInstructions()" [innerHtml]="item" style="font-size:20px; line-height: 22px; margin-bottom: 4px; font-weight: 300;"></li>
            </ul>
            <p [innerHTML]="isFlightInfo?.message"></p>
            <p>##Print Date Time{{currentDate}}</p>
        </mat-card>
    </section>
</div>
